import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const transferDesignModule = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    recipes: {},
    prices: {},
    imageUrls: {},
    modelName: null,
    designData: null,
    isPersonalizationInvalid: null,
    isCustomizerTransferredModel: false
  }
};

export default transferDesignModule;
